export default __webpack_public_path__ + "static/media/social-media-pic-1.8bd43a8c.png";